<script setup>
  import { computed, watchEffect, defineAsyncComponent } from 'vue'
  import { useSheetContentComponent } from '@/composables/useSheetContentComponent';
  import { useSheetController } from "@/composables/useSheetsController";
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import { useMapStore } from '@/stores/MapStore';
  import { useMapAdStore } from '@/stores/MapAdStore';
  import SheetBase from "@/components/SheetBase.vue";
  import LoaderCircle from '@/components/LoaderCircle.vue';

  const props = defineProps({
    position: {
      type: String,
      default: 'primary'
    }
  });  
  
  const type = 'source';
  const isDesktop = useMediaQuery('(min-width: 840px)');

  useSheetController.registerSheet(type, props.position);

  const mapStore = useMapStore();
  const mapAdStore = useMapAdStore();

  const components = {
    SheetContentForecastModels: defineAsyncComponent(() => import('@/components/SheetContentForecastModels.vue')),
    SheetContentUserProfiles: defineAsyncComponent(() => import('@/components/SheetContentUserProfiles.vue'))
  };

  const isSheetOpen = computed(() => {
    return useSheetController.sheets[type].open;
  })

  const startingHeightState = computed(() => isDesktop.value ? 'maximized' : 'mid');

  watchEffect(() => {
    if (isSheetOpen.value) {
      useSheetController.sheets.source.content = 
        mapStore.state.useProfileId 
          ? 'user-profiles' 
          : mapStore.mapMode.toLowerCase() === 'fx' && mapStore.state.forecastSelectorNeeded
            ? 'forecast-models'
            : null;


      if (!useSheetController.sheets.source.content) useSheetController.closeSheet('source');
    }

    
    mapAdStore.blockingAdPanelOpen = isSheetOpen.value;
  })
</script>

<template>
    <SheetBase 
      :type="type" 
      :starting-height-state="startingHeightState" 
      :position="props.position"
      v-slot="{ transtionName }"
    >
    <Suspense timeout="200">
      <component
        v-if="isSheetOpen"
        :is="useSheetContentComponent(type, components)" 
        :type="type"
        :transtionName="transtionName"
      />

      <template #fallback>
        <LoaderCircle />
      </template>      
    </Suspense>
  </SheetBase>
</template>